module.exports = __webpack_public_path__ + "img/1.6e20ea51.jpg";